import {
  Directive,
  Input,
  TemplateRef,
  HostListener,
  OnInit,
  ElementRef,
  ComponentRef,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { OverlayRef, Overlay, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { RxTooltipComponent } from '@nrwl/rx-tooltip';
import { fromEvent, pipe, Subject } from 'rxjs';

@Directive({
  selector: '[rxTooltip]',
})
export class TooltipDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input('rxTooltip') content: string | TemplateRef<any> | any;
  private overlayRef: OverlayRef;
  private tooltipRef: ComponentRef<RxTooltipComponent>;
  public mouseup = false;
  public detach$ = new Subject();
  public detach = true;

  constructor(
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    private overlay: Overlay,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      const positionStrategy = this.overlayPositionBuilder
        .flexibleConnectedTo(this.elementRef)
        .withPositions([
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
          {
            originX: 'center',
            originY: 'bottom',
            overlayX: 'center',
            overlayY: 'top',
            offsetX: 0,
            offsetY: 0,
          },
        ])
        .withFlexibleDimensions(false)
        .withPush(true);

      this.overlayRef = this.overlay.create({ positionStrategy });
      const enter$ = fromEvent(this.overlayRef.overlayElement, 'mouseenter');
      const leave$ = fromEvent(this.overlayRef.overlayElement, 'mouseleave');

      this.detach$.subscribe(() => {
        if (this.detach) {
          this.mouseup = false;
          this.overlayRef.detach();
        }
      });

      enter$.subscribe(() => {
        this.detach = false;
      });

      leave$.subscribe(() => {
        this.mouseup = false;
        this.detach = true;
        this.overlayRef.detach();
      });
    });
  }

  ngAfterViewInit(): void {}

  ngOnDestroy() {}

  private getPositionStrategy() {
    return this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)

      .withFlexibleDimensions(false)
      .withPush(true);
  }

  @HostListener('mouseenter')
  show() {
    if (!this.mouseup) {
      this.mouseup = true;
      if (!this.overlayRef) {
        return;
      }
      const tooltipPortal = new ComponentPortal(RxTooltipComponent);

      this.tooltipRef = this.overlayRef.attach(tooltipPortal);

      if (typeof this.content === 'string') {
        this.tooltipRef.instance.text = this.content;
      } else {
        this.tooltipRef.instance.content = this.content;
      }
    }
    setTimeout(() => {
      this.overlayRef.updatePosition();
      this.cd.detectChanges();
    });
  }

  @HostListener('window:resize')
  onResize() {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      const positionStrategy = this.getPositionStrategy();
      this.overlayRef.updatePositionStrategy(positionStrategy);
      this.overlayRef.updatePosition();
    }
  }

  @HostListener('click')
  click() {
    this.mouseup = false;
    this.overlayRef.detach();
  }

  @HostListener('mouseleave')
  leave() {
    setTimeout(() => {
      this.detach$.next(null);
    }, 50);
  }
}
